module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"table.results":"Results per page:","table.newer":"Newer","table.older":"Older"},"fr":{}}')
  delete Component.options._Ctor
}
